<template>
  <section class="card-recharge-bed">
    <title-bar title="普通卡新办"
               :isDefaultColor="true"></title-bar>
    <div class="img-box">
      <upload :getImgUrl="getImgUrl"
              :isImgShow="!imgUrl_front">
        <img class="show-img"
             v-if="!imgUrl_front"
             src="../assets/img/upload/card_id.png"
             alt="">
        <img class="show-img"
             v-else
             :src="imgUrl_front"
             alt="">
      </upload>
      <upload :getImgUrl="getImgUrl_reverse"
              :isImgShow="!imgUrl_reverse">
        <img class="show-img"
             v-if="!imgUrl_reverse"
             src="../assets/img/upload/card_photo.png"
             alt="">
        <img class="show-img"
             v-else
             :src="imgUrl_reverse"
             alt="">
      </upload>
      <!-- <img src="../assets/img/upload/card_photo.png"
           class="show-img" /> -->

    </div>
    <div class="info-box">

      <div class="info-li">
        <span>姓名</span>
        <input type="tel"
               v-model="name"
               maxlength="18"
               placeholder="请输入持卡人姓名" />
      </div>
      <div class="info-li">
        <span>手机号码</span>
        <input type="tel"
               v-model="phone"
               maxlength="11"
               placeholder="请输入持卡人手机号码" />
      </div>
      <div class="info-li">
        <span>身份证号</span>
        <input v-model="IDCard"
               maxlength="18"
               placeholder="请输入持卡人身份证号" />
      </div>
      <div class="info-li">
        <span>押金</span>

        <span style="color:#EF4141"
              v-if="getType == '01'">￥{{(newCardSelfTakeAmount[0])/100}}</span>
        <span style="color:#EF4141"
              v-else>￥{{(newCardMailAmount[0])/100}}</span>

      </div>
      <div class="info-li">
        <span>取卡方式</span>
        <div class="select"
             style="margin-top:0px;outline:none;border:1px solid #fff;border-radius:4px;position:relative;">

          <select required
                  class="orderTimeDataSel"
                  v-model="getType">
            <option value=""
                    disabled
                    selected
                    hidden><span>请选择取卡方式</span>

            </option>
            <option value="01">自取（7个工作日后领取）</option>
            <option value="02">邮寄（¥{{(newCardMailAmount[1])/100}}）</option>

            <!-- <option value="02">邮寄（¥10）</option> -->
          </select>
        </div>
        <img src="../assets/img/cardRecharge/icon_down.png"
             class="down" />
      </div>
      <div class="info-li"
           v-if="getType == '01'">
        <span>取卡地点</span>
        <div class="select"
             style="margin-top:0px;outline:none;border:1px solid #fff;border-radius:4px;position:relative;">

          <select required
                  class="orderTimeDataSel"
                  v-model="address">
            <option value=""
                    disabled
                    selected
                    hidden><span>请选择取卡地点</span>
            </option>
            <option :value="item.address_code"
                    v-for="(item, index) in addressList"
                    :key="index">{{item.take_address}}</option>
          </select>
        </div>
        <img src="../assets/img/cardRecharge/icon_down.png"
             class="down" />
      </div>
    </div>
    <div class="info-box"
         v-if="getType =='02'">

      <div class="info-li">
        <span>收件人姓名</span>
        <input placeholder="请输入收件人姓名"
               v-model="mailName" />
      </div>
      <div class="info-li">
        <span>收件人电话</span>
        <input type="tel"
               placeholder="请输入收件人电话"
               v-model="mailPhone" />
      </div>
      <div class="info-li">
        <span>收件人地址</span>
        <input placeholder="请输入收件人地址"
               v-model="mailAddress" />
      </div>
    </div>
    <div class="recharge">
      <!-- <p>充值金额</p> -->
      <!-- <ul>
        <li v-for="(item, index) in numList"
            :key="index"
            @click="choosePay(index)"
            :class="index==payNum?'checked':''">{{item}}元</li>
      </ul> -->
      <p>支付方式</p>
      <div class="pay-type">
        <div class="icon-type">
          <img src="../assets/img/cardRecharge/icon_jianhang.png" />
          <span>{{payList[0].payWayName}}</span>

        </div>
        <div class="icon-choose">
          <!-- <input type="radio"
                 v-model="checked"
                 @click="flag"
                 v-if="!checked" /> -->
          <div v-if="!checked"
               @click="flag"
               class="radio"></div>

          <img src="../assets/img/cardRecharge/choose.png"
               class="choose"
               @click="flag"
               v-else />
        </div>

      </div>
      <div class="btn-box"
           v-if="!checked">
        <div>去支付</div>
      </div>
      <div class="btn-ready"
           v-else
           @click="submit">
        <div>去支付</div>
      </div>

    </div>
    <fail-info :isShow="isShow_fail"
               title='失败'
               :content="msg">
      <div @click="back">确定</div>
    </fail-info>

  </section>
</template>
<script>
import { checkCard, address, cardAmountSetting, cardNewApply } from '@/api/list'
import { goToPay } from '@/api/charge'
import TitleBar from '@/components/TitleBar.vue'
import failInfo from '@/components/failInfo.vue'
import Upload from '@/components/Upload.vue'
import { Toast } from 'vant';


export default {
  name: 'cardRecharge',
  data () {
    return {
      isGetCard_front: false,
      isGetCard_reverse: false,
      imgUrl_front: '',
      imgUrl_reverse: '',
      name: '',
      IDCard: '',
      cardNo: '',
      phone: '',
      leftNum: '',
      payNum: 0,
      checked: false,
      cardType: '',
      getType: '',
      address: '',
      addressList: [],
      isShow_fail: false,
      msg: '',
      newCardMailAmount: [],
      newCardSelfTakeAmount: [],

      plateOrderId: '',
      payList: [],
      mailName: "",
      mailAddress: "",
      mailPhone: ""


    }
  },
  computed: {

  },
  components: { TitleBar, failInfo, Upload },
  mounted () {
    // document.querySelector('.img-pos').onload = function () {
    //   this.style.visible = 'hidden'
    //   this.style.height = 'auto'
    //   this.style.width = 'auto'
    //   this.style.transform = 'rotate(0deg)'
    //   if (this.offsetWidth < this.offsetHeight) {
    //     this.style.transform = 'rotate(90deg)'
    //     this.style.height = document.querySelector('.upload-label').offsetWidth + 'px'
    //   } else {
    //     this.style.width = document.querySelector('.upload-label').offsetWidth + 'px'
    //   }
    //   this.style.visible = 'visibility'
    // }
    this.getAddress();
  },
  created () {
    this.getPageInfoList()
  },
  methods: {
    getPageInfoList () {
      this.payList = JSON.parse(window.sessionStorage.getItem('cityParamConfig')).payWay.filter(item => {
        if (item.payWayCode === '20') {
          item.icon = wxIcon
        }
        return item.payWayCode !== '00'
      })
      console.log(this.payList)
    },
    goPay () {
      const params = {
        plateOrderId: this.plateOrderId,
        IDCard: this.IDCard,
        balance: '0',
        cardArea: '1002',
        name: this.name,
        payPurpose: '08',
        payWay: "80",//根据后台获取支付方式
        phoneNum: JSON.parse(window.sessionStorage.getItem('userInfo')).phoneNum,
        // rechargeAmount: parseFloat(this.amountMoney) * 100,
        rechargeAmount: this.getType == '01' ? this.newCardSelfTakeAmount[0] * 1 + this.newCardSelfTakeAmount[1] * 1 : this.newCardMailAmount[0] * 1 + this.newCardMailAmount[1] * 1,
        readWay: '01',
        type: '0211',
        goodsOrderNum: '1',
        tradeType: 'H5',
        redirectUrl: window.location.origin +
          '?phoneNum=' +
          JSON.parse(window.sessionStorage.getItem('userInfo')).phoneNum
      }
      goToPay(params).then(data => {
        if (data.respCode === '01') {
          window.location.href = data.data.payParam
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    },
    getImgUrl (img) {
      this.isGetCard_front = true
      this.imgUrl_front = img
    },
    getImgUrl_reverse (img) {
      this.isGetCard_reverse = true
      this.imgUrl_reverse = img
    },
    back () {
      this.isShow_fail = false
    },
    getAddress () {
      // 显示loading
      // const toast = Toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   message: '加载中...',
      // });
      // console.log(Toast)
      // this.bus.$emit('loading', true);
      address().then(data => {
        if (data.respCode === '01') {
          this.addressList = data.data.data;
          this.getNum();
        } else {
          this.isShow_fail = true;
          this.msg = data.respMsg;
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    },
    getNum () {
      cardAmountSetting().then(data => {
        if (data.respCode === '01') {
          for (let i = 0; i < data.data.data.length; i++) {
            let item = data.data.data[i];
            if (item.cardType == '99') {
              console.log(item)
              this.newCardMailAmount = item.newCardMailAmount.split("&");
              this.newCardSelfTakeAmount = item.newCardSelfTakeAmount.split("&");
              return;
            }
          }

        } else {
          this.isShow_fail = true;
          this.msg = data.respMsg;
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })
    },
    flag () {
      this.checked = !this.checked
    },
    choosePay (index) {
      this.payNum = index;
    },
    returnRouter () {
      this.$router.push({
        name: 'yearCheckSelect'
      })
    },
    mail () {
      if (!this.mailName) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入收件人姓名'
        })
        return false
      }
      if (!this.mailAddress) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入收件人地址'
        })
        return false
      }
      if (!this.mailPhone) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入收件人电话'
        })
        return false
      }
      const params = {
        name: this.name,
        cardType: "99",
        IDCard: this.IDCard,
        phone: this.phone,
        businessType: '01',
        takeType: this.getType,
        idFrontImage: this.imgUrl_front,
        photo: this.imgUrl_reverse,
        amount: this.newCardMailAmount[0] * 1 + this.newCardMailAmount[1],
        mailName: this.mailName,
        mailAddress: this.mailAddress,
        mailPhone: this.mailPhone
      }
      cardNewApply(params).then(data => {
        if (data.respCode === '01') {
          this.plateOrderId = data.data.plateOrderId;
          this.goPay();
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })

    },
    selfGet () {
      if (!this.address) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请选择取卡地点'
        })
        return false
      }
      const params = {
        name: this.name,
        cardType: "99",
        IDCard: this.IDCard,
        phone: this.phone,
        businessType: '01',
        takeType: this.getType,
        takeAddressCode: this.address,
        idFrontImage: this.imgUrl_front,
        photo: this.imgUrl_reverse,
        amount: this.newCardSelfTakeAmount[0] * 1 + this.newCardSelfTakeAmount[1]
      }
      cardNewApply(params).then(data => {
        if (data.respCode === '01') {
          this.plateOrderId = data.data.plateOrderId;
          this.goPay();
        } else {
          this.$eventBus.$emit('getTipsInfo', {
            msg: data.respMsg
          })
        }
      }).catch(err => {
        this.$eventBus.$emit('getTipsInfo', {
          msg: err
        })
      })


    },
    submit () {
      if (!this.isGetCard_front) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请上传身份证正面照'
        })
        return false
      }
      if (!this.isGetCard_reverse) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请上传一寸免冠照'
        })
        return false
      }
      if (!this.name) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请填写姓名'
        })
        return false
      }
      if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(this.phone)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入合法手机号'
        })
        return false
      }
      if (!/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(this.IDCard)) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请输入合法的身份证号码'
        })
        return false
      }
      if (!this.getType) {
        this.$eventBus.$emit('getTipsInfo', {
          msg: '请选择取卡方式'
        })
        return false
      }
      if (this.getType == '01') {
        this.selfGet()
      } else {
        this.mail()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.card-recharge-bed {
  height: 100%;
  background: #e8ebf0;
}

.img-box {
  width: calc(100% - 64px);
  // height: 300px;
  padding: 32px;
  background-color: #fff;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;

  // img {
  //   width: calc(50% - 13px);
  //   height: 236px;
  // }
}
.info-box {
  background: #fff;
  margin-top: 16px;
  .orderTimeDataSel {
    height: 40px;
    -webkit-appearance: none;
    appearance: none;
    border: none;
    font-size: 26px;
    padding: 0px 20px;
    display: block;
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #ffffff;
    color: #333333;
    border-radius: 4px;
  }
  > .info-li {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 24px 32px;
    font-size: 26px;
    font-family: 宋体;
    color: #333333;
    border-bottom: 1px solid #e8ebf0;
    .down {
      width: 14px;
      height: 8px;
    }
    img {
      width: 48px;
      height: 48px;
    }

    span {
      display: inline-block;
      width: 180px;
      white-space: nowrap;
      text-align: left;
      // text-align-last: justify;
    }
    input {
      flex: 1;
      border: 0;
      padding-left: 20px;
    }
  }
  > .warning {
    padding: 30px 32px;
    font-size: 22px;
    font-family: 宋体;
    font-weight: 400;
    color: #ef4141;
    text-align: left;
  }
}
.recharge {
  margin-top: 16px;
  width: 100%;
  background-color: #fff;
  padding-bottom: 340px;
  p {
    padding: 24px 32px;
    text-align: left;
    font-size: 30px;
    font-family: 宋体;
    font-weight: 500;
    color: #333333;
  }
  ul {
    width: calc(100% - 64px);
    height: 80px;
    line-height: 80px;
    margin-left: 32px;
    margin-bottom: 32px;
    display: flex;
    justify-content: space-between;
    li {
      width: 31%;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #e8ebf0;
      font-size: 30px;
      font-family: 宋体;
      font-weight: 400;
      color: #384253;
    }
    .checked {
      background: #2489ff;
      border: 1px solid #5fbaf3;
      color: #ffffff;
    }
  }
  .pay-type {
    padding: 0px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .icon-type {
      display: flex;
      align-items: center;
    }
    img {
      width: 48px;
      height: 48px;
    }
    .choose {
      width: 40px;
      height: 40px;
    }
    span {
      margin-left: 10px;
    }
    .radio {
      width: 20px;
      height: 20px;
      border: 2px solid rgb(163, 158, 158);
      border-radius: 50%;
    }
  }
}
.btn-box {
  margin: 50px 60px;
  background: #f5f6f8;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #8f98a8;
}
.btn-ready {
  margin: 50px 60px;
  background: #2489ff;
  border-radius: 44px 44px 44px 44px;
  padding: 20px 0;
  border-radius: 70px;
  margin-top: 100px;
  font-size: 30px;
  font-family: 宋体;
  font-weight: 400;
  color: #ffffff;
}
.show-img {
  max-width: calc(100% - 13px);
  height: 236px;
}
input::-webkit-input-placeholder {
  color: #8f98a8;
}
</style>
